export const getAvailableIntegrationsUrl = () => '/business/available_integrations';

export const getNewIntegrationsUrl = () => '/business/integrations/new';

export const getPostConfigurationFieldUrl = (id?: string) => `/business/integrations/${id}/post_configurations`;

export const getIntegrationsUrl = () => '/business/integrations';

export const getUpdateIntegrationsUrl = (integrationId: string) => `/business/integrations/${integrationId}`;

export const getIntegrationUrl = (integrationId: number) => `/business/integrations/${integrationId}`;

export const getInitialSyncUrl = (integrationId: number | string) =>
  `/business/integrations/${integrationId}/initial_sync`;

export const getManualSyncUrl = (integrationId: number | string) =>
  `/business/integrations/${integrationId}/manual_sync`;

export const getOauthRedirectUrl = (code: string) => `/integrations/${code}/oauth_redirect`;

export const getIntegrationToolsUrl = (integrationId: string) =>
  `/business/integrations/${integrationId}/integration_tools`;

export const getCurveDentalOperatoriesUrl = () => '/integrations/curve_dental/operatories';

export const getSynchronizerLogsUrl = () => '/business/synchronizer_logs';

export const getSynchronizedItemsUrl = (synchronizerLogId: number | string) =>
  `/business/synchronizer_logs/${synchronizerLogId}/synchronized_items`;
